import React from 'react';
import { Col, Row, Card, CardBody, Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Heading from '../common/Heading';

export default function SnIntegration({ loadingSN, snIntegrationTest }) {
  return (
    <>
      <Heading title="Service Status" subtitle={`Current service status`} className="mb-2 mt-3" icon="cog" />
      <Row noGutters>
        <Col xs={6} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
          <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
            {/* <Background className={`bg-card`} /> */}
            <CardBody className="position-relative">
              <Row>
                <Col>
                  <h6 className="dash-vendor-label">ServiceNow</h6>
                </Col>
                {loadingSN ? (
                  <Col className="text-right d-inline-flex flex-row-reverse">
                    <Spinner size={'sm'} color="primary" />
                  </Col>
                ) : (
                  <Col className="text-right d-inline-flex flex-row-reverse">
                    <p
                      className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} ${
                        loadingSN ? 'loading-skeleton' : ' '
                      } small`}
                    >
                      <span className="pb-2">{snIntegrationTest?.valid ? 'OPERATIONAL' : 'ERROR'}</span>
                    </p>
                    <p className="small">
                      <span className="fa-stack fa-xs mr-1">
                        <FontAwesomeIcon
                          icon="circle"
                          className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} fa-stack-2x`}
                        />
                        <FontAwesomeIcon
                          icon={snIntegrationTest?.valid ? 'check' : 'exclamation'}
                          className="fa-stack-1x"
                          inverse
                        />
                      </span>
                    </p>
                  </Col>
                )}
              </Row>
              {loadingSN ? (
                <div />
              ) : !snIntegrationTest?.valid ? (
                <div>
                  <div className="col">
                    <div className="row">
                      <Link to={'/integrations/servicenow'}>
                        <Button color="falcon-default" className="btn btn-falcon-default mt-2" size="sm">
                          Configure
                        </Button>
                      </Link>
                    </div>
                  </div>

                  <>
                    <div className="active">
                      <small>{snIntegrationTest?.error?.message}</small>
                    </div>
                  </>
                </div>
              ) : (
                <></>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}

SnIntegration.propTypes = {
  snIntegrationTest: PropTypes.object,
  loadingSN: PropTypes.bool
};
